import { type IFirestoreModel } from '@principle-theorem/shared';
import { type Permission } from './permission';

export interface IRole extends IFirestoreModel {
  name: string;
  permissions: Permission[];
}
